angular.module('impactx.basket').controller('ServicePeriodCtrl', [
    '$scope',
    '$mdDialog',
    'themeFactory',
    'TranslationService',
    'servicePeriod',
    'readOnly',
    ServicePeriodCtrl]);

function ServicePeriodCtrl($scope, $mdDialog, themeFactory, TranslationService, servicePeriod, readOnly) {
    $scope.theme = themeFactory.getTheme();
    var self = this;
    //new object needed
    $scope.servicePeriod = JSON.parse(JSON.stringify(servicePeriod));
    $scope.readOnly = readOnly;

    $scope.saveLabel = TranslationService.get("save");
    $scope.abortLabel = TranslationService.get("abort");
    $scope.deleteLabel = TranslationService.get("delete");
    $scope.requiredLabel = TranslationService.get("required");
    $scope.maxLengthError = TranslationService.get("errors_maxlength");

    $scope.$watch(function () {
        return $scope.servicePeriod.startDate.dateValue;
    }, function (newValue, oldValue) {
        if (newValue !== oldValue) {
            self.recalcEndDate();
        }
    });

    $scope.$watch(function () {
        return $scope.servicePeriod.runTime.value;
    }, function (newValue, oldValue) {
        if (newValue !== oldValue) {
            self.recalcEndDate();
        }
    });

    self.recalcEndDate = function () {
        if ($scope.servicePeriod.startDate.dateValue && $scope.servicePeriod.runTime.value) {
            $scope.servicePeriod.endDate.dateValue = new Date($scope.servicePeriod.startDate.dateValue.getTime());
            $scope.servicePeriod.endDate.dateValue.setMonth($scope.servicePeriod.endDate.dateValue.getMonth() + parseInt($scope.servicePeriod.runTime.value));
            $scope.servicePeriod.endDate.dateValue.setDate($scope.servicePeriod.endDate.dateValue.getDate() - 1);

        }
        else {
            $scope.servicePeriod.endDate.dateValue = null;
        }
    };

    self.delete = function () {
        $mdDialog.cancel(true);
    };
    self.cancel = function () {
        $mdDialog.cancel(false);
    };
    self.answer = function () {
        $mdDialog.hide($scope.servicePeriod);
    };
}